import { Breadcrumb, Input, message, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BackIcon } from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import style from "./SystemParameterEdit.module.css";
import axios from "axios";
import { ROUTES } from "../../../constant/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { doGet } from "../../../api/baseAPI";
import CustomToogle from "../../../component/toogle/CustomToogle";
import MSSDayOff from "../../../component/select/MSSDayOff";
import { GROLOG_URL } from "../../../constant/apiConstant";
import { validParameter } from "./validation";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import ModalConfirmLeave from "../../../component/modal/ModalConfirmLeave";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from "../../../util/Util";

const SystemParameterEdit = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [checked, setChecked] = useState(false);
  const [day, setDay] = useState([]);
  const [error, setError] = useState([]);
  const [charValue, setCharValue] = useState();
  const [change, setChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchData();
  }, []);
  const api = GROLOG_URL;
  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async () => {
    let id = 1;
    let res = await doGet(
      `/grolog-parameter/${location.state}?${param}`,
      token
    );
    setDetail(res?.data?.payload);
    setCharValue(res?.data?.payload?.char_value);
    setChecked(res?.data?.payload?.char_value === "Y" ? true : false);
    setDay([res?.data?.payload?.char_value]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (val, name) => {
    setChange(true);
    onChanged(dispatch, true);
    if (detail?.type === "F") {
      let eror = validParameter("char_value_f", val.target.value, t);
      setError({ ...error, ...eror });
      setCharValue(val.target.value);
      setDetail((prevsValue) => {
        return {
          ...prevsValue,
          [name]: val.target.value,
        };
      });
    } else if (detail?.type === "I") {
      let eror = validParameter("char_value_i", val.target.value, t);
      setError({ ...error, ...eror });
      setCharValue(val.target.value);
      setDetail((prevsValue) => {
        return {
          ...prevsValue,
          [name]: val.target.value,
        };
      });
    } else {
      let eror = validParameter("char_value_c", val.target.value, t);
      setError({ ...error, ...eror });
      setCharValue(val.target.value);
      setDetail((prevsValue) => {
        return {
          ...prevsValue,
          [name]: val.target.value,
        };
      });
    }
  };

  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const onSubmit = async () => {
    let sub = {
      char_value:
        detail.type === "L" ? (charValue ? charValue : "N") : charValue,
      updated_at: detail?.updated_at,
    };
    let sub_c = {
      char_value_c: charValue,
      updated_at: detail?.updated_at,
    };
    let data_f = {
      char_value_f: charValue,
      updated_at: detail?.updated_at,
    };
    let sub_i = {
      char_value_: Number(charValue),
      updated_at: detail?.updated_at,
    };

    let errors = {};
    for (const key in detail.type === "C"
      ? sub_c
      : detail.type === "I"
      ? sub_i
      : sub) {
      const option = validParameter(
        key,
        detail.type === "C"
          ? sub_c
          : detail.type === "I" || detail.type === "F"
          ? sub_i
          : sub[key],
        t
      );
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      let res = await doPut(
        `/grolog-parameter/update/${location.state}?${param}`,
        token,
        sub
      );
      setSuccessModalOpen(true);
    }
  };

  const handleToogle = () => {
    setChange(true);
    setChecked(checked ? false : true);
    setCharValue(checked ? "N" : "Y");
  };

  const getDay = (value) => {
    setChange(true);
    const val = value?.data.map((el) => el.value.split("-")[0].split(" ")[0]);
    let vals =
      value.data[0]?.value === "All"
        ? [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ]
        : value?.data.map((el) => el.id);
    let eror = validParameter("char_value", vals, t);
    setError({ ...error, ...eror });
    setDay(vals);
    setCharValue(vals.toString());
  };

  const actModal = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.PARAMETER.LIST,
    });
  };

  return (
    <>
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.PARAMETER.LIST}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been updated"
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`System Parameter`}
          menuLevel4={`Edit ${detail.code}`}
        />

        <div className="flex items-center justify-between">
          <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.PARAMETER.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />
            <h1 className="font-sans-bold text-2xl" id="title">
              Edit {detail.code}
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <div className="flex">
              <div>
                <div className="flex">
                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[500px] mb-[24px]">
                      <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                        {t("PARAMETER:SYSTEM_PARAMETER_INFO")}
                      </h3>
                    </div>

                    <div className="w-[500px] mb-[24px]">
                      <label className="font-roboto text-[16px] font-medium">
                        {t("PARAMETER:PARAMETER_ID")}
                      </label>
                      <div className="flex w-[500px]">
                        <Select
                          className="w-[500px]"
                          dropdownStyle={{ backgroundColor: "white" }}
                          size="large"
                          value={detail?.code}
                          disabled={detail.code}
                          onChange={(value) => handleChange(value, "to_menu")}
                        />
                      </div>

                      <div className="w-[500px] mb-[24px] mt-2">
                        <label className="font-roboto text-[16px] font-medium">
                          {t("Parameter Name")}
                        </label>
                        <div className="flex w-[500px]">
                          <Input
                            className="mt-[8px] h-[47px] w-[500px]"
                            value={detail?.name}
                            disabled={detail.name}
                            onChange={(value) =>
                              handleChange(value, "charValue")
                            }
                          />
                        </div>
                      </div>

                      <div className="w-[500px] mb-[24px]">
                        <label className="font-roboto text-[16px] font-medium">
                          {t("Parameter Value")}
                        </label>
                        <div className="mt-[8px] h-[47px] w-[500px]">
                          {detail.type === "L" ? (
                            <CustomToogle
                              namespace={"tglsetallaccess"}
                              checked={
                                checked
                                  ? checked
                                  : charValue === "Y"
                                  ? true
                                  : false
                              }
                              handleChange={() => handleToogle()}
                            />
                          ) : detail.type === "D" ? (
                            <MSSDayOff
                              getValue={(value) => getDay(value)}
                              level={1}
                              isEdit={true}
                              isSelectAll={day.flagCheckAll}
                              currentValue={
                                day?.data?.length !== 0 &&
                                day?.data !== undefined
                                  ? day?.data.map((el) => el.value)
                                  : undefined
                              }
                              status={error.char_value ? "error" : ""}
                              error={error}
                              errorNamespace={"char_value"}
                            />
                          ) : (
                            <>
                              {detail?.code ===
                                "@MaxWeightCapacityPercentage" ||
                              detail?.code ===
                                "@MaxVolumeCapacityPercentage" ? (
                                <>
                                  <Space.Compact>
                                    <Input
                                      style={{ width: "480px", height: "47px" }}
                                      value={
                                        // detail.type === "F" ? charValue+"%" :
                                        charValue
                                      }
                                      status={
                                        error.char_value_c ||
                                        error.char_value_f ||
                                        error?.char_value_i
                                          ? "error"
                                          : ""
                                      }
                                      onChange={(value) =>
                                        handleChange(value, "char_value")
                                      }
                                    />
                                    <Input
                                      style={{ width: "15%" }}
                                      value="%"
                                      disabled
                                    />
                                  </Space.Compact>
                                </>
                              ) : (
                                <>
                                  <Input
                                    className="mt-[8px] h-[47px] w-[500px]"
                                    value={
                                      // detail.type === "F" ? charValue+"%" :
                                      charValue
                                    }
                                    status={
                                      error.char_value_c ||
                                      error.char_value_f ||
                                      error?.char_value_i
                                        ? "error"
                                        : ""
                                    }
                                    onChange={(value) =>
                                      handleChange(value, "char_value")
                                    }
                                  />
                                </>
                              )}
                            </>
                          )}
                          <div className="text-red-100">
                            {error?.char_value_c ||
                              error?.char_value_i ||
                              error.char_value_f}
                          </div>

                          {/* <CustomToogle
                            namespace={"tglsetallaccess"}
                            checked={checked}
                            handleChange={() => handleToogle()}
                          /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            /> */}
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          <PrimaryButton
            text={t("USER_DETAIL:SAVE")}
            action={() => onSubmit()}
          />
          <SecondaryButton
            text={t("USER_DETAIL:CANCEL")}
            action={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.PARAMETER.LIST)
            }
          />
        </div>
      </div>
    </>
  );
};
export default SystemParameterEdit;
